import { useState, useEffect } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "@/lib/firebase/config";
import { COLLECTIONS } from "@/lib/constants";

export interface Category {
  id: string;
  name: string;
  code?: string;
  description?: string | null;
  icon?: string | null;
  color?: string | null;
  imageUrl?: string | null;
  order?: number;
  isActive: boolean;
  taux?: number;
  packagingPrice?: number;
  glovoGlobalId?: string;
  source?: string; // "GLOVO_SYNC" ou undefined pour manual
  createdAt: any;
  updatedAt: any;
}

export function useCategories(activeOnly: boolean = false) {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function loadCategories() {
      try {
        setLoading(true);
        setError(null);

        let q;
        if (activeOnly) {
          q = query(
            collection(db, COLLECTIONS.CATEGORIES),
            where("isActive", "==", true)
          );
        } else {
          q = query(collection(db, COLLECTIONS.CATEGORIES));
        }

        const snapshot = await getDocs(q);
        const categoriesData = snapshot.docs
          .map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }) as Category)
          .sort((a, b) => {
            // Trier par order puis par name
            const orderA = a.order ?? 999;
            const orderB = b.order ?? 999;
            if (orderA !== orderB) return orderA - orderB;
            return (a.name || "").localeCompare(b.name || "");
          });

        setCategories(categoriesData);
      } catch (err: any) {
        console.error("Error loading categories:", err);
        setError(err.message || "Erreur lors du chargement des catégories");
      } finally {
        setLoading(false);
      }
    }

    loadCategories();
  }, [activeOnly]);

  return { categories, loading, error, refetch: () => {} };
}

